import { Tile } from "@carbon/react";
import type { HTMLAttributes, ReactNode } from "react";

type CardVariant = "default" | "review" | "login";

type CardProps = HTMLAttributes<HTMLDivElement> & {
  variant?: CardVariant;
  children: ReactNode;
};

const VARIANT_CLASS: Record<CardVariant, string> = {
  default: "",
  review: "wiki-review-card",
  login: "login-card",
};

export function Card({
  variant = "default",
  className,
  children,
  ...rest
}: CardProps) {
  const classes = [VARIANT_CLASS[variant], className].filter(Boolean).join(" ");
  return (
    <Tile className={classes || undefined} {...rest}>
      {children}
    </Tile>
  );
}
